module.exports = __webpack_public_path__ + "static/img/img02.5da2ef2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv026/sp/img02.jpg
// module id = jhUW
// module chunks = 0